/**
 * 홈 큐레이션 API.
 *
 * 영구지침: docs/develop/frontend/home-page-portal-spec.md §4.1
 */
import { useQuery } from '@tanstack/react-query'
import apiClient from '@/lib/api/client'

export interface TipPost {
  id: number
  slug: string
  title: string
  category: string
  thumbnailUrl: string | null
}

export interface RecommendedFacility {
  id: number
  name: string
  facilityType: string | null
  addressSido: string | null
  addressSigungu: string | null
  evaluationGrade: string | null
  thumbnailUrl: string | null
}

export interface SelfAssessmentCta {
  title: string
  subtitle: string
  buttonLabel: string
  linkPath: string
}

export interface TodayCuration {
  snapshotDate: string
  tipPost: TipPost | null
  recommendedFacility: RecommendedFacility | null
  selfAssessmentCta: SelfAssessmentCta
}

export const TODAY_CURATION_QUERY_KEY = ['home', 'today-curation'] as const

export function useTodayCuration() {
  return useQuery({
    queryKey: TODAY_CURATION_QUERY_KEY,
    queryFn: async () => {
      const res = await apiClient.get('/home/today-curation')
      return res.data.data as TodayCuration
    },
    staleTime: 12 * 60 * 60 * 1000, // 12h
    gcTime: 24 * 60 * 60 * 1000, // 24h
  })
}
